module.exports = __webpack_public_path__ + "img/Memorial-Hall-t-24705-007.fc1f6973.jpg";